(ns manage.adset-decision-tree-page.tree-generation-ocp.classification
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/InputAdornment$default" :as InputAdornment]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj ->js]]
            [common.util :as util]
            [manage.adset-decision-tree-page.tree-generation-ocp.hook :as h]
            [uix.core :as uix :refer [$ defui]]))

(defui option-with-icon [{:keys [li-props option]}]
  ($ :li li-props
     ($ Stack {:direction "row"
               :alignItems "center"
               :gap 1
               :sx #js {:flex 1
                        :overflow "hidden"}}
        ($ SvgIcon {:component (.-icon option)})
        ($ Typography {:component "span"
                       :sx #js {:flex 1}}
           (.-label option)))))

(defn render-option-with-icon [props option]
  ($ option-with-icon {:key (.-value option) :li-props props :option option}))

(defui autocomplete-text-field-with-icon
  [{:keys [^js text-field-props value error]}]
  ($ TextField (util/spread-props
                text-field-props
                #js {:slotProps (when value
                                  #js {:input
                                       (util/spread-obj
                                        (.-InputProps text-field-props)
                                        #js {:startAdornment
                                             ($ InputAdornment {:position "start"
                                                                :sx #js {:ml 1 :mr 0}}
                                                ($ SvgIcon {:component (.-icon value)}))})})
                     :error (boolean error)})))

(defui autocomplete-with-icons
  [{:keys [options]
    {{:keys [onChange value]} :field
     {:keys [error]} :fieldState :as props} :control-props}]
  (let [render-input (uix/use-callback (fn [props]
                                         ($ autocomplete-text-field-with-icon
                                            {:text-field-props props
                                             :value (->js value)
                                             :error error}))
                                       [value error])]
    ($ Autocomplete (util/spread-props (:field props)
                                       {:value (or (->js value) #js {:value nil :label ""})
                                        :size "small"
                                        :options options
                                        :renderOption render-option-with-icon
                                        :sx #js {:width "30rem"}
                                        :onChange (fn [_e value] (onChange value))
                                        :renderInput render-input}))))

(defui node-type-select [{:keys [column-name form-control]}]
  (let [options (h/use-node-type-options)]
    ($ rhf/Controller
       {:name column-name
        :rules #js {:required true}
        :control (:control form-control)
        :render (fn [^js props] ($ autocomplete-with-icons {:control-props (->clj props)
                                                            :options options}))})))

(defui column-list-item [{:keys [column-name] :as props}]
  ($ ListItem {:key column-name
               :sx #js {:borderRadius 2
                        :bgcolor "grey.80"
                        :mb 2
                        :px 2
                        :py 1
                        :justifyContent "space-between"}}
     ($ Typography column-name)
     ($ node-type-select props)))

(defui classification [{:keys [classification-form-control]}]
  (let [strategy-columns (h/use-strategy-columns)]
    (when strategy-columns
      ($ List {}
         (for [column-name (sort strategy-columns)]
           ($ column-list-item {:key column-name
                                :column-name column-name
                                :form-control classification-form-control}))))))
